import './CommentsPanel.scss'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'react-fa'
import Assignee from '../Assignee'
import LinkifiedText from '../LinkifiedText'
import TaskDetailsLoadingIndicator from './TaskDetailsLoadingIndicator'

import { SHORT_DATE_FORMAT, TIME_FORMAT } from '../../constants/momentFormats'

class CommentsPanel extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { comments, localMoment, localize, timeZone, projectMembers, deleteComment } = this.props

    if (comments && !comments.length) {
      return (null)
    }

    return (
      <div className='task-modal__comments'>
        <div className='task-modal__field'>{localize('taskBoards.Label_Comments')}</div>
        <div className='task-modal__value'>

          { !comments
            ? <TaskDetailsLoadingIndicator />
            : (
            comments
              .sort((comment, nextComment) => comment.createdOn.localeCompare(nextComment.createdOn))
              .map((comment) => {
                let createdOnMoment = localMoment.utc(comment.createdOn).tz(timeZone)
                let createdOn = createdOnMoment.isSame(localMoment.utc(), 'day')
                  ? localize('taskBoards.Text_TodayAtTime')
                  : localize('taskBoards.Text_DateAtTime')
                createdOn = createdOn
                  .replace('{date}', createdOnMoment.format(SHORT_DATE_FORMAT))
                  .replace('{time}', createdOnMoment.format(TIME_FORMAT))

                let user = projectMembers[comment.createdBy] || {
                  firstName: 'Non',
                  lastName: 'Member'
                }

                return <div className={'task-modal__comment'} key={comment.id}>

                  <Assignee assignment={{
                    userId: comment.createdBy,
                    firstName: user.firstName,
                    lastName: user.lastName
                  }} />
                  <div className='task-modal__comment-text'>
                    <LinkifiedText key={comment.id} text={comment.text}/>
                    <span className='task-modal__comment-date'>
                      { createdOn }
                    </span>
                  </div>
                  <div className='task-modal__comment-delete-container'>
                    { comment.actions.delete &&
                      <Icon
                        className='task-modal__comment-delete-button'
                        name='remove'
                        title={localize('taskBoards.Label_DeleteComment')}
                        onClick={() => { deleteComment(comment.id) }}
                      />
                    }
                  </div>
                </div>
              })
            )}
        </div>
      </div>
    )
  }
}

CommentsPanel.propTypes = {
  projectMembers: PropTypes.object.isRequired,
  comments: PropTypes.array,
  timeZone: PropTypes.string.isRequired,
  localMoment: PropTypes.any.isRequired,
  deleteComment: PropTypes.func.isRequired,
  localize: PropTypes.func.isRequired
}

export default CommentsPanel



// WEBPACK FOOTER //
// ./src/components/TaskDetails/CommentsPanel.js